import {
  iconAndroidLogo,
  iconAppleLogo,
  iconGooglePlayLogo,
  iconIosLogo,
  iconPcLogo,
  iconWebLogo,
} from 'Assets/_Legacy/Platforms'

export const PLATFORMS_NAMES = {
  ANDROID: 'Android',
  IOS: 'iOS',
  PC: 'PC',
  WEB: 'Web',
  APP_STORE: 'App Store',
  GOOGLE_PLAY: 'Google Play',
}

export const PLATFORMS = [
  { title: PLATFORMS_NAMES.ANDROID, logo: iconAndroidLogo },
  { title: PLATFORMS_NAMES.IOS, logo: iconIosLogo },
  { title: PLATFORMS_NAMES.PC, logo: iconPcLogo },
  { title: PLATFORMS_NAMES.WEB, logo: iconWebLogo },
  { title: PLATFORMS_NAMES.APP_STORE, logo: iconAppleLogo },
  { title: PLATFORMS_NAMES.GOOGLE_PLAY, logo: iconGooglePlayLogo },
]
